import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Artists = () => {
  const database = useStaticQuery(graphql`
  query {
    allDatabaseJson {
      edges {
        node {
          names {
            en
            name
            hiragana
            katakana
          }
          id
          zone{
            zone
            num
          }
        }
      }
    }
  }

  `)
  const artists = database.allDatabaseJson.edges
  var out = {
    zone1: [],
    zone2: [],
    zone3: [],
  }
  artists.map((artist, i) => {
    out[artist.node.zone.zone].push(
      <li key={i} className={"artist"}>
        <Link to={artist.node.zone.zone + '/' + artist.node.names.en}>
          <p>{artist.node.names.name}</p>
        </Link>
      </li>
    )
  })
  return (
    <Layout>
      <SEO title={"Artists"} />
      <div className={"contents artists"}>
        <section className={"title"}>
          <h1>掲載作家一覧</h1>
          <p>本ウェブサイトでは、作家との協議によりページを「zone1」「zone2」「zone3」の、3つに区分しました。</p>
        </section>
        <section>
          <ul>
            <li className={"zone_wrap"}>
              <h2>zone1</h2>
              <ul className={"artist-wrap"}>
                {out.zone1}
              </ul>
            </li>
            <li className={"zone_separater"}>
              <p>-</p>
            </li>
            <li className={"zone_wrap"}>
              <h2>zone2</h2>
              <ul className={"artist-wrap"}>
                {out.zone2}
              </ul>
            </li>
            <li className={"zone_separater"}>
              <p>-</p>
            </li>
            <li className={"zone_wrap"}>
              <h2>zone3</h2>
              <ul className={"artist-wrap"}>
                {out.zone3}
              </ul>
            </li>
          </ul>
        </section>
        <section>
        </section>
      </div>
    </Layout>
  )
}

export default Artists
